export default __webpack_public_path__ + "static/Button-ef5eff4ac58c7922f2b2f377df9590bf.png";